"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductPricing = void 0;
const big_js_1 = require("big.js");
const config_1 = __importDefault(require("@src/config"));
const types_1 = require("@src/types");
const coefficientVAT = new big_js_1.Big(100).add(config_1.default.pricing.VAT).div(100).toNumber();
const getProductPricing = ({ productCount, couponDiscount = 0, productId, }) => {
    if (new big_js_1.Big(productCount).lte(0)) {
        throw new Error(`${productCount} is not a valid product amount`);
    }
    const DEFAULT_PRICE = new big_js_1.Big(config_1.default.pricing.products[productId].levels[0].price);
    const couponDiscountCoefficient = new big_js_1.Big(100).minus(new big_js_1.Big(couponDiscount)).div(new big_js_1.Big(100));
    const pricingLevelsSortedByLimit = [...config_1.default.pricing.products[productId].levels].sort((fst, snd) => fst.limit - snd.limit);
    const bestPriceLevel = pricingLevelsSortedByLimit[pricingLevelsSortedByLimit.length - 1];
    const pricingLevel = pricingLevelsSortedByLimit.find(item => new big_js_1.Big(productCount).lte(item.limit));
    const pricePerUnit = pricingLevel ? new big_js_1.Big(pricingLevel.price) : new big_js_1.Big(bestPriceLevel.price);
    if (productId === types_1.ProductId.offerCV && productCount >= 20) {
        const maxPrice = new big_js_1.Big(99);
        return {
            productPrice: pricePerUnit.times(coefficientVAT).times(couponDiscountCoefficient).toNumber(),
            productPriceWithoutVat: pricePerUnit.times(couponDiscountCoefficient).toNumber(),
            totalPrice: maxPrice.times(coefficientVAT).times(couponDiscountCoefficient).toNumber(),
            totalPriceWithoutVat: maxPrice.times(couponDiscountCoefficient).toNumber(),
            totalPriceBeforeCouponDiscount: maxPrice.times(coefficientVAT).toNumber(),
            totalPriceBeforeCouponDiscountWithoutVat: maxPrice.toNumber(),
            originalPrice: maxPrice.times(coefficientVAT).toNumber(),
            originalPriceWithoutVat: maxPrice.toNumber(),
            productCouponDiscount: maxPrice
                .times(coefficientVAT)
                .times(couponDiscountCoefficient)
                .minus(maxPrice.times(coefficientVAT))
                .toNumber(),
            productCouponDiscountWithoutVat: maxPrice.times(couponDiscountCoefficient).minus(maxPrice).toNumber(),
            discount: maxPrice.minus(maxPrice).times(coefficientVAT).toNumber(),
            discountWithoutVat: maxPrice.minus(maxPrice).toNumber(),
            discountRelative: new big_js_1.Big(100).minus(pricePerUnit.div(DEFAULT_PRICE).times(100).round()).toNumber(),
        };
    }
    return {
        productPrice: pricePerUnit.times(coefficientVAT).times(couponDiscountCoefficient).toNumber(),
        productPriceWithoutVat: pricePerUnit.times(couponDiscountCoefficient).toNumber(),
        totalPrice: pricePerUnit.times(productCount).times(coefficientVAT).times(couponDiscountCoefficient).toNumber(),
        totalPriceWithoutVat: pricePerUnit.times(productCount).times(couponDiscountCoefficient).toNumber(),
        totalPriceBeforeCouponDiscount: pricePerUnit.times(productCount).times(coefficientVAT).toNumber(),
        totalPriceBeforeCouponDiscountWithoutVat: pricePerUnit.times(productCount).toNumber(),
        originalPrice: DEFAULT_PRICE.times(productCount).times(coefficientVAT).toNumber(),
        originalPriceWithoutVat: DEFAULT_PRICE.times(productCount).toNumber(),
        productCouponDiscount: pricePerUnit
            .times(productCount)
            .times(coefficientVAT)
            .times(couponDiscountCoefficient)
            .minus(pricePerUnit.times(productCount).times(coefficientVAT))
            .toNumber(),
        productCouponDiscountWithoutVat: pricePerUnit
            .times(productCount)
            .times(couponDiscountCoefficient)
            .minus(pricePerUnit.times(productCount))
            .toNumber(),
        discount: DEFAULT_PRICE.times(productCount)
            .minus(pricePerUnit.times(productCount))
            .times(coefficientVAT)
            .toNumber(),
        discountWithoutVat: DEFAULT_PRICE.times(productCount).minus(pricePerUnit.times(productCount)).toNumber(),
        discountRelative: new big_js_1.Big(100).minus(pricePerUnit.div(DEFAULT_PRICE).times(100).round()).toNumber(),
    };
};
exports.getProductPricing = getProductPricing;
